<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>

            <li> {{ $t('general.content_detail') }}</li>
          </ul>
        </nav>
      </div>

      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left">
            <span> {{ $t('general.content_detail') }}</span>
          </h2>
        </div>
      </div>
      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red"><i class="uil-exclamation-triangle"></i> {{ error }}</p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>

      <div class="card">

        <div class="card-header actions-toolbar border-0">
          <div class="d-flex justify-content-between align-items-center">
            <div class="row" style="width:100%">
              <div class=" col-md-1  search-icon ">
                <i class="uil-search"></i>
              </div>
              <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
                <input v-model="filter.search" :placeholder="$t('general.search')" autofocus=""
                  class="uk-search-input shadow-0 uk-form-small" type="search" />
              </div>
            </div>
            <div class="d-flex">
              <sort-dropdown :sort-options="sortOption" :title="sortTitle" @sort-selected="sortOrder" />
            </div>
            <a :uk-tooltip="$t('filters.export_excell')" class="btn btn-icon btn-hover  btn-circle" href="javascript:;"
              @click="exportContents">
              <i class="fa-file-excel fa"></i>
            </a>
          </div>
        </div>

        <div v-if="loading">
          <default-loading></default-loading>
        </div>

        <div v-else>
          <div class="table-responsive">
            <table class="table align-items-center">
              <thead>
                <tr>
                  <th>{{ $t('general.first_name_and_last_name') }}</th>
                  <th>{{ $t('general.email') }}</th>
                  <th>{{ $t('general.content_title') }}</th>
                  <th>{{ $t('general.assignment_name') }}</th>
                  <th>{{ $t('general.duration') }}</th>
                  <th>{{ $t('general.completion_percentage') }}</th>
                  <th>{{ $t('general.start_date') }}</th>
                  <th>{{ $t('general.completion_date') }}</th>
                  <th>{{ $t('general.deleted_at') }}</th>
                  <th>{{ $t('general.status') }}</th>

                  <!-- Checklist kolonları -->
                  <template v-if="hasCheckListInteractions">
                    <template v-for="(interaction, index) in firstCheckListInteractions">
                      <th :key="'check-name-' + index">
                        Kontrol Maddesi {{ index + 1 }}
                      </th>
                      <th :key="'check-response-' + index">
                        İşaretlenme Durumu {{ index + 1 }}
                      </th>
                    </template>
                  </template>

                  <!-- Video kolonları -->
                  <template v-if="hasVideoInteractions">
                    <template v-for="(interaction, index) in firstVideoInteractions">
                      <th :key="'video-question-' + index">
                        Video Sorusu {{ index + 1 }}
                      </th>
                      <th :key="'video-response-' + index">
                        Verilen Cevap {{ index + 1 }}
                      </th>
                      <th :key="'video-result-' + index">
                        Sonuç {{ index + 1 }}
                      </th>
                    </template>
                  </template>

                  <th>{{ $t('general.actions') }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item, index) in contentItems">
                  <tr :key="index">
                    <td>{{ item.full_name }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.content_name }}</td>
                    <td>{{ item.assignment_name || '-' }}</td>
                    <td>{{ item.duration }}</td>
                    <td>{{ item.completion_percentage }}%</td>
                    <td>{{ timeFromDate(item.started_at) }}</td>
                    <td>{{ timeFromDate(item.completed_at || '-') }}</td>
                    <td>{{ timeFromDate(item.deleted_at || '-') }}</td>

                    <td style="width: 70px; text-align:center;">
                      <span :class="[
                        'uk-badge',
                        'uk-badge-small',
                        item.is_completed ? 'uk-badge-success' : 'uk-badge-warning'
                      ]" style="font-size:12px; padding:2px 8px; min-width:32px; display:inline-block;"
                        :uk-tooltip="item.is_completed ? $t('general.completed') : $t('general.on_going')">
                        {{ item.is_completed ? '✓' : '…' }}
                      </span>
                    </td>

                    <!-- Checklist -->
                    <template v-if="hasCheckListInteractions">
                      <template v-for="(interaction, interactionIndex) in firstCheckListInteractions">
                        <td :key="'check-name-' + interactionIndex">
                          {{ getCheckListInteraction(item, interactionIndex) }}
                        </td>

                        <td :key="'check-response-' + interactionIndex">
                          {{ getCheckListResponse(item, interactionIndex) }}
                        </td>
                      </template>
                    </template>

                    <!-- Video -->
                    <template v-if="hasVideoInteractions">
                      <template v-for="(interaction, interactionIndex) in firstVideoInteractions">
                        <td :key="'video-question-' + interactionIndex">
                          {{ getVideoInteraction(item, interactionIndex, 'question_text') }}
                        </td>

                        <td :key="'video-response-' + interactionIndex">
                          {{ getVideoInteraction(item, interactionIndex, 'response') }}
                        </td>

                        <td :key="'video-result-' + interactionIndex">
                          {{
                            getVideoInteraction(item, interactionIndex, 'is_correct')
                            ? 'Doğru'
                            : 'Yanlış'
                          }}
                        </td>
                      </template>
                    </template>

                    <td style="width: 60px; text-align:center;">
                      <button v-if="item.interactions && item.interactions.length > 0"
                        class="uk-button uk-button-default uk-button-small uk-button-icon"
                        style="padding:2px 8px; font-size:14px; min-width:32px;" @click="showDetailsModal(item)"
                        :uk-tooltip="$t('general.detail')">
                        <i class="uil uil-eye"></i>
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>

        <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>

      </div>

      <!-- Interaction Modal -->
      <div v-if="showInteractionModal" :class="['uk-modal', showInteractionModal ? 'uk-open' : '']"
        style="display: block;">
        <div class="uk-modal-dialog uk-modal-body">
          <button class="uk-modal-close-default" type="button" uk-close @click="closeDetailsModal"></button>
          <h4 class="uk-modal-title">{{ selectedUser }}</h4>
          <table class="uk-table uk-table-divider uk-table-small">
            <thead>
              <tr>
                <th>{{ $t('general.id') }}</th>
                <th>{{ $t('general.description') }}</th>
                <th>{{ $t('general.result') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(interaction, i) in selectedInteractions" :key="i">
                <td>{{ interaction.id }}</td>
                <td>{{ interaction.description }}</td>
                <td>
                  <span :class="['uk-badge', interaction.result === 'correct' ? 'uk-badge-success' : 'uk-badge-danger']">
                    {{ $t(`general.${interaction.result}`) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import store from "@/core/services";
import SortDropdown from "@/view/components/dropdown/SortDropdown.vue";
import axios from "axios";
import contentModule, {
  ERROR,
  GET_ITEMS,
  ITEM,
  LOADING,
  MODULE_NAME as CONTENT_MODULE_NAME,
} from "@/core/services/store/content.module";

import DefaultLoading from "@/view/components/loading/DefaultLoading";
import Pagination from "@/assets/components/Pagination.vue";
import moment from "moment-timezone";
export default {
  name: "ContentEdit",
  components: { Pagination, DefaultLoading, SortDropdown },
  data() {
    return {
      pagination: null,
      successMessage: "",
      errorMessages: [],
      page: 1,
      filter: {
        search: null,
        order: "desc",
        sort: "id",
      },
      sortOption: [
        { key: 'text-asc', sort: 'id', order: 'asc', label: this.$t("sorting.a_z") },
        { key: 'text-desc', sort: 'id', order: 'desc', label: this.$t("sorting.z_a") },
        { key: 'created_at-asc', sort: 'created_at', order: 'asc', label: this.$t("sorting.created_at_asc") },
        { key: 'created_at-desc', sort: 'created_at', order: 'desc', label: this.$t("sorting.created_at_desc") },
      ],
      sortTitle: this.$t("filters.order.sort"),
      contentItems: [],
      showInteractionModal: false,
      selectedInteractions: [],
      selectedUser: null,
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(CONTENT_MODULE_NAME, contentModule);
  },
  computed: {
    loading() {
      return store.getters[CONTENT_MODULE_NAME + "/" + LOADING];
    },

    item: {
      get() {
        return store.getters[CONTENT_MODULE_NAME + "/" + ITEM];
      },
      set(value) { },
    },

    error: {
      get() {
        return store.getters[CONTENT_MODULE_NAME + "/" + ERROR];
      },
      set(value) { },
    },

    hasCheckListInteractions() {
      return this.contentItems.some(
        item =>
          item.check_list_interactions &&
          item.check_list_interactions.length > 0
      );
    },

    firstCheckListInteractions() {
      const item = this.contentItems.find(
        item =>
          item.check_list_interactions &&
          item.check_list_interactions.length > 0
      );

      return item ? item.check_list_interactions : [];
    },

    hasVideoInteractions() {
      return this.contentItems.some(
        item =>
          item.video_interactions &&
          item.video_interactions.length > 0
      );
    },

    firstVideoInteractions() {
      const item = this.contentItems.find(
        item =>
          item.video_interactions &&
          item.video_interactions.length > 0
      );

      return item ? item.video_interactions : [];
    },
  },
  methods: {
    getCheckListInteraction(item, index) {
      if (
        !item.check_list_interactions ||
        !item.check_list_interactions[index]
      ) {
        return '-';
      }

      const interaction = item.check_list_interactions[index];

      return (
        interaction.name +
        (interaction.is_mandatory ? ' (Zorunlu)' : '')
      );
    },

    getCheckListResponse(item, index) {
      if (
        !item.check_list_interactions ||
        !item.check_list_interactions[index]
      ) {
        return '-';
      }

      return item.check_list_interactions[index].response
        ? 'İşaretlendi'
        : 'İşaretlenmedi';
    },

    getVideoInteraction(item, index, field) {
      if (
        !item.video_interactions ||
        !item.video_interactions[index]
      ) {
        return '-';
      }

      return item.video_interactions[index][field];
    },
    timeFromDate(value) {
      const m = moment.utc(value, 'YYYY-MM-DD HH:mm:ss', true);
      return m.isValid() ? m.local().locale(this.secureLocalStorage("language")).format('DD/MM/YYYY HH:mm:ss') : '-';
    },

    exportContents() {
      axios
        .get(
          process.env.VUE_APP_BACKEND_APP_URL + "/api/report/export/contents/" + this.$route.params.id,
          {
            params: {
              time: Date.now()
            },
            responseType: "blob",
            headers: this.apiHeaders,
          }
        )
        .then((response) => {
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          let day = moment().format("YYYYMMDDHHMMSS");
          let fileName = "contents_report_list_" + day + ".xlsx";
          fileLink.setAttribute("download", fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
        });
    },
    filterResult() {
      let self = this;
      let filters = {
        like: self.filter.search,
        page: self.page,
        sort: self.filter.sort,
        order: self.filter.order,
      };

      store.dispatch(CONTENT_MODULE_NAME + "/" + GET_ITEMS, {
        url: `api/report/contents/${this.$route.params.id}`,
        filters: filters,
      }).then((response) => {
        this.pagination = response;
        this.contentItems = response.data;
      });
    },
    setPage(page) {
      this.page = page;
      this.filterResult();
    },
    sortOrder({ order, sort }) {
      this.page = 1;
      this.filter.order = order;
      this.filter.sort = sort;

      this.filterResult();
    },
    showDetailsModal(item) {
      this.selectedInteractions = item.interactions;
      this.selectedUser = item.full_name;
      this.showInteractionModal = true;
    },
    closeDetailsModal() {
      this.showInteractionModal = false;
      this.selectedInteractions = [];
      this.selectedUser = null;
    },
  },
  mounted() {
    this.filterResult();
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500);

  },
  watch: {
    "filter.search": function (val) {
      this.page = 1;
      this.debouncedFilterSearch();
    },
  },

};
</script>


<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-badge {
  padding: 5px 10px;
  border-radius: 3px;
}

.uk-badge-success {
  background-color: #32d296;
  color: #fff;
}

.uk-badge-warning {
  background-color: #faa05a;
  color: #fff;
}

.uk-badge-danger {
  background-color: #f0506e;
  color: #fff;
}

.uk-badge-small {
  font-size: 12px;
  padding: 2px 8px;
}

.uk-button-small {
  font-size: 12px;
  padding: 2px 8px;
}

.uk-button-icon {
  min-width: 32px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
